import { useCallback, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

interface Option {
  value: string;
  label: string;
}

export const useServiceTypeOptions = () => {
  const { token } = useSelector((state: any) => state?.authReducer);
  const [limit, setLimit] = useState(200);
  const [serviceTypeOptions, setServiceTypeOptions] = useState<{
    loading: boolean;
    list: Option[];
  }>({
    loading: false,
    list: [],
  });
 
  const getServiceTypeOptions = useCallback(async () => {
    setServiceTypeOptions({ loading: true, list: [] });

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/service-type/all?limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const mappedOptions = res?.data?.serviceTypes?.map((serviceType: any) => ({
        value: serviceType?.value,
        label: serviceType?.name.replace("_", " "),
      }));

      setServiceTypeOptions({
        loading: false,
        list: mappedOptions || [],
      });
    } catch (error) {
      console.error("Failed to fetch service types", error);
      setServiceTypeOptions({ loading: false, list: [] });
    }
  }, [limit,token]);

  return {
    serviceTypeOptions,
    getServiceTypeOptions,
  };
};